import axios from "@/modules/axios";
import {sortBy} from "lodash";

export default {
	namespaced: true,

	state: {
		data: []
	},

	mutations: {
		data(state, data) {
			state.data = data;
		}
	},

	actions: {
		async data({commit}) {
			const {data: {data}} = await axios.get("client/categories", {params: {count: 1000}});
			commit("data", data);
		}
	},

	getters: {
		data(state) {
			return sortBy(state.data, "name");
		}
	}
};
